export const PROCESSING_TASK = {
  SELECTING: Symbol("@@PROCESSING_TASK/SELECTING"),
  TRANSLATE_TRANSFORMING: Symbol(`@@PROCESSING_TASK/TRANSLATE_TRANSFORMING`),
  SCALE_TRANSFORMING: Symbol(`@@PROCESSING_TASK/SCALE_TRANSFORMING1`),
  ROTATE_TRANSFORMING: Symbol(`@@PROCESSING_TASK/ROTATE_TRANSFORMING1`),
  PATH_EDITING: Symbol(`@@PROCESSING_TASK/PATH_EDITING`),
  PATH_EDITING_TRANSLATE_TRANSFORMING: Symbol(
    `@@PROCESSING_TASK/PATH_EDITING_TRANSLATE_TRANSFORMING`
  ),
};
